import './MobileMenu.scss';
class MobileMenu {
	constructor(node) {
		this.node = node;
	}
	init() {
		var t = this;
		var body = document.body;
		var menu = t.node;
		var menuContent = menu.querySelector('.size__content');
		var hamburger = document.querySelector('#hamburger');

		hamburger.addEventListener('click', function() {

			if( hamburger.classList.contains('active') ) {
				hamburger.classList.remove('active');
				menu.classList.remove('active');
				body.classList.remove('disableScroll');
			} else {
				hamburger.classList.add('active');
				menu.classList.add('active');
				body.classList.add('disableScroll');
			}

		});
		menu.addEventListener('click', function() {
			hamburger.classList.remove('active');
			menu.classList.remove('active');
			body.classList.remove('disableScroll');
		});
		menuContent.addEventListener('click', function(e) {
			e.stopPropagation();
		});
		window.addEventListener('resize', function() {
			if( window.innerWidth > 1024 ) {
				body.classList.remove('disableScroll');
			}
			if( window.innerWidth <= 1024 && menu.classList.contains('active') ) {
				body.classList.add('disableScroll');
			} 

		});

	}
}
JSModules['MobileMenu'] = MobileMenu;
export default MobileMenu;